import React from 'react';
import BaseComponent from '../../common/BaseComponent/BaseComponent';
import PaymentWayRow from "./PaymentWayRow";

import styles from './ComponentPaymentWay.scss';
import {ContextDataStore} from "../../common/helpers/HelperGlobalDataStore";
import Button, {buttons} from "../../common/primitives/Button";
import PaymentCardRow from "./PaymentCardRow";
import {__t} from "../../common/lang/text-resource";
import RenderIf from "../../common/primitives/RenderIf/RenderIf";
import attentionImg from './img/attention.png';

class ComponentPaymentWay extends BaseComponent {

	hasRegisteredCards = this.state.componentData.registeredCards.length > 0;
	selectedPaymentWay = this.props.data.componentData.selected;
	hideComponentAutoRenew = this.props.data.componentData.hideComponentAutoRenew;
	selectedCardToken = this.props.data.componentData.selectedCartToken;
	showAllPaymentWays = !this.hasRegisteredCards || (this.selectedPaymentWay !== '' && this.selectedCardToken === '');
	isSUMode = this.props.data.componentData.isSUMode;
	cardSelected = false;
	isAutoRenewChecked = true;

	getComponentState = () => ({
		selectedPaymentWay: this.selectedPaymentWay,
		isAutoRenewChecked: this.isAutoRenewChecked,
		orderId: this.state.componentData.orderId,
		registeredCardSelected: this.cardSelected,
	});

	selectPaymentWay = (event, isRegisteredCard) => {
		this.isAutoRenewChecked = true;
		this.selectedCardToken = '';
		this.selectedPaymentWay = event.target.value;

		this.cardSelected = isRegisteredCard === true;

		this.setState(this.state);
	};
	onChangeAutoRenew = () => {
		this.isAutoRenewChecked = !this.isAutoRenewChecked;
		this.setState(this.state);
	}

	continue = () => {
		const actionData = this.getComponentState();
		this.ajaxCall('ActionChangePaymentWay', actionData)
	};

	render() {

		let total = this.context.get('ComponentCart');

		if (total) {
			total = total.componentData;
		} else {
			total = this.context.get('ComponentCartCompleted');
			if (total) {
				total = total.componentData;
			}
		}

		if (total) {
			total = total.endTotal;
			total = parseFloat(total);
		} else {
			total = 0;
		}

		const paymentWays = this.state.componentData.options;
		const registeredCards = this.state.componentData.registeredCards;
		const defaultCardId = this.state.componentData.defaultCardId;

		let isCardSelected = (this.selectedPaymentWay === '') && (this.hasRegisteredCards === true);
		isCardSelected = isCardSelected || ((this.selectedCardToken != '') && (this.hasRegisteredCards === true));
		isCardSelected = isCardSelected && (registeredCards.length > 0);

		if (isCardSelected) {
			this.selectedPaymentWay = defaultCardId !== '' ? defaultCardId : registeredCards[0].id;
			this.cardSelected = true;
		}

		if (this.state.componentData.isCustomerAutopayRestricted == true) {
			this.isAutoRenewChecked = false;
		}

		return (
		  <div
			className={`${(this.props.showAsPage) ? styles.inPage : ''} ${styles.container}`}
			data-layout="padding-top--xs text-left">
			  <RenderIf
				condition={this.isSUMode === true && this.hasRegisteredCards === true && this.cardSelected === true}>
				  <table className={styles.attentionBlock}>
					  <tbody>
					  <tr>
						  <td>
							  <img src={attentionImg}/>
						  </td>
						  <td>
							  <p className={styles.yellowBlock}>
								  <strong>{__t('Внимание:')}</strong> <br/>
								  {__t('ще-направите-директно-плащане-със-запазената-картec70d7')}
							  </p>
						  </td>
					  </tr>
					  </tbody>
				  </table>
			  </RenderIf>
			  {
				this.hasRegisteredCards === true && registeredCards.map((cardData, cardKey) =>
				  <div key={cardKey} className={styles.paymentWayRow} data-test={`payment-way-${cardData.id}`}>
					  <PaymentCardRow
						cardData={cardData}
						selected={this.selectedPaymentWay === cardData.id || this.selectedCardToken === cardData.token}
						onChange={(event) => this.selectPaymentWay(event, true)}
						autoRenewChecked={this.isAutoRenewChecked}
						hideComponentAutoRenewMessage={this.hideComponentAutoRenew}
						onChangeAutoRenew={this.onChangeAutoRenew}/>
				  </div>
				)
			  }
			  {
				this.hasRegisteredCards === true &&
				<div className={`${styles.container} ${styles.buttonContainer}`}>
					<div data-layout="row gutter-none start">
						<div data-layout="col 12 10@md offset-1@sm offset-2@md">
							<Button onClick={() => {
								this.showAllPaymentWays = !this.showAllPaymentWays;
								this.setState(this.state);
							}}
									value={this.showAllPaymentWays === true ? __t("Скриване на начини за плащане") : __t("Всички начини на плащане")}
									className={`${buttons.buttonLink} ${buttons.action} ${styles.showAllPaymentWaysButton}`}/>
							<span className={styles.icon}/>
						</div>
					</div>
				</div>

			  }
			  {
				this.showAllPaymentWays === true && this.hasRegisteredCards === true && <br/>
			  }
			  {
				this.showAllPaymentWays === true && paymentWays.map((paymentWay, key) =>
				  <div key={key} className={styles.paymentWayRow} data-test={`payment-way-${paymentWay.id}`}>
					  {
						  <PaymentWayRow
							name={paymentWay.name}
							id={paymentWay.id}
							orderTotalSum={total}
							selected={this.selectedPaymentWay === paymentWay.id}
							available_sum={paymentWay.available_sum}
							available_sum_currency={paymentWay.available_sum_currency}
							onChange={(event) => this.selectPaymentWay(event, false)}
							autoRenewChecked={this.isAutoRenewChecked}
							hideComponentAutoRenewMessage={this.hideComponentAutoRenew}
							onChangeAutoRenew={this.onChangeAutoRenew}/>
					  }

				  </div>
				)
			  }
			  {
				this.props.hideContinueButton !== true &&
				<div data-layout="text-center padding-top--smm">
					<Button onClick={this.continue} name={'do_continue'} value={__t('Продължи')}/>
				</div>
			  }
		  </div>
		);
	}
}

ComponentPaymentWay.defaultProps = {
	hideContinueButton: true
};
ComponentPaymentWay.propTypes = {};

// React Context binding
ComponentPaymentWay.contextType = ContextDataStore;

export default ComponentPaymentWay;